import {
  IDatabaseTableModel,
  IGenericSelectDataModel,
  IGenericSelectWhereConditionModel,
  IGenericSelectWhereDataModel
} from "@kuika/kuika-cl-model";
import {
  EManagedDbUpdateWhereConditionOperator,
  EManagedDbUpdateWhereType,
  ESymbolCategory,
  ISymbol
} from "@kuika/kuika-cl-model/src/models/builder.dtos";
import _ from "lodash";
import * as React from "react";
import KuikaBadge from "../../../../ui-kit/kuika-badge/kuika-badge";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import { FilterOrGroupComponent } from "./filter-or-group";
import { FilterSelectGroupComponent } from "./filter-select-group";

export interface IFilterState {}

export interface IFilterProps {
  tables: IDatabaseTableModel[];
  selectData: IGenericSelectDataModel;
  updateSelectData: (newData: IGenericSelectDataModel) => void;
  getTypeIcon: (type: string) => React.ReactElement;
  isModal?: boolean;
}

class Filter extends React.PureComponent<IFilterProps, IFilterState> {
  constructor(props: IFilterProps) {
    super(props);
    this.state = {};
  }

  handleClickAnd = () => {
    const selectData = _.cloneDeep(this.props.selectData);
    selectData.whereData.push({
      type: EManagedDbUpdateWhereType.and,
      andCondition: {
        tableName: "",
        tableSchema: "",
        colName: "",
        colSqlDataType: "",
        conditionOperator: EManagedDbUpdateWhereConditionOperator.isEqualTo,
        paramSymbol: { category: ESymbolCategory.fixed } as ISymbol
      }
    });
    this.props.updateSelectData(selectData);
    const element = document.querySelector(".filter-area");
    if (element) {
      setTimeout(() => {
        element.scrollTo({
          top: element.scrollHeight + 100,
          behavior: "smooth"
        });
      }, 100);
    }
  };

  handleClickOrGroup = () => {
    const selectData = _.cloneDeep(this.props.selectData);
    selectData.whereData.push({
      type: EManagedDbUpdateWhereType.orGroup,
      orConditions: [
        {
          tableName: "",
          tableSchema: "",
          colName: "",
          colSqlDataType: "",
          conditionOperator: EManagedDbUpdateWhereConditionOperator.isEqualTo,
          paramSymbol: { category: ESymbolCategory.fixed } as ISymbol
        },
        {
          tableName: "",
          tableSchema: "",
          colName: "",
          colSqlDataType: "",
          conditionOperator: EManagedDbUpdateWhereConditionOperator.isEqualTo,
          paramSymbol: { category: ESymbolCategory.fixed } as ISymbol
        }
      ]
    });
    this.props.updateSelectData(selectData);
    const element = document.querySelector(".filter-area");
    if (element) {
      setTimeout(() => {
        element.scrollTo({
          top: element.scrollHeight + 100,
          behavior: "smooth"
        });
      }, 100);
    }
  };

  handleUpdateOrData = (newData: IGenericSelectWhereDataModel, idx: number) => {
    const selectData = _.cloneDeep(this.props.selectData);
    if (newData.orConditions?.length === 0) {
      selectData.whereData.splice(idx, 1);
    } else {
      selectData.whereData[idx] = newData;
    }
    this.props.updateSelectData(selectData);
  };

  handleDelete = (idx: number) => {
    const selectData = _.cloneDeep(this.props.selectData);
    selectData.whereData.splice(idx, 1);
    this.props.updateSelectData(selectData);
  };

  handleUpdateAndData = (newData: IGenericSelectWhereConditionModel, idx: number) => {
    const selectData = _.cloneDeep(this.props.selectData);
    selectData.whereData[idx].andCondition = newData;
    this.props.updateSelectData(selectData);
  };

  render() {
    return (
      <>
        {this.props.selectData.whereData.length > 0 && (
          <>
            <div className="filter-conditions-container">
              {this.props.selectData.whereData.map((x, idx) => {
                const hasMoreData = this.props.selectData.whereData.length - 1 > idx;
                return (
                  <div key={idx} className="filter-condition-item">
                    {x.type === EManagedDbUpdateWhereType.and ? (
                      x.andCondition && (
                        <FilterSelectGroupComponent
                          type="and"
                          tables={this.props.tables}
                          selectedTables={this.props.selectData.tables}
                          data={x.andCondition}
                          updateData={(newData) => this.handleUpdateAndData(newData, idx)}
                          hasMoreData={false}
                          delete={() => this.handleDelete(idx)}
                          getTypeIcon={this.props.getTypeIcon}
                          calculatedFields={this.props.selectData.calculatedFields || []}
                        />
                      )
                    ) : (
                      <FilterOrGroupComponent
                        tables={this.props.tables}
                        selectedTables={this.props.selectData.tables}
                        data={x}
                        hasMoreData={false}
                        updateData={(newData) => this.handleUpdateOrData(newData, idx)}
                        getTypeIcon={this.props.getTypeIcon}
                        calculatedFields={this.props.selectData.calculatedFields || []}
                      />
                    )}
                    {hasMoreData && (
                      <div className="filter-connector">
                        <div className="filter-connector__line" />
                        <KuikaBadge content="AND" color="grey" />
                        <div className="filter-connector__line" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
        <div className="generic-sql__filter__buttons">
          <KuikaButton type="text" onClick={this.handleClickAnd}>
            <KuikaSvg name="plus" width={16} height={16} />
            AND
          </KuikaButton>
          <KuikaButton type="text" onClick={this.handleClickOrGroup}>
            <KuikaSvg name="plus" width={16} height={16} />
            OR-GROUP
          </KuikaButton>
        </div>
      </>
    );
  }
}

export const FilterComponent = Filter;
